/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_ProductGet } from '../models/Model_ProductGet';
import type { Shared_Languages } from '../models/Shared_Languages';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductService {
    /**
     * @param id
     * @param language
     * @returns Model_ProductGet Success
     * @throws ApiError
     */
    public static getApiV1Products(
        id: ConvertDatesToStrings<string>,
        language?: ConvertDatesToStrings<Shared_Languages>,
    ): CancelablePromise<Model_ProductGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/products/{id}',
            path: {
                'id': id,
            },
            query: {
                'language': language,
            },
        });
    }
}
